import type {
  AddFieldPlacementTarget,
  AuthoredEntityOrSingleSchema,
  GeneratedSchemaField,
  LoadedAuthoredGeneratedSchema
} from '@cli-types/core-engine/add-field.js'
import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { normalizeAddFieldSlot } from './normalize-add-field-slot.js'

export function applySlotToField(
  loaded: LoadedAuthoredGeneratedSchema,
  target: AddFieldPlacementTarget,
  field: GeneratedSchemaField,
  slot?: string
): GeneratedSchemaField {
  const normalizedSlot = normalizeAddFieldSlot(slot)
  if (!normalizedSlot || loaded.kind === 'form') {
    return field
  }

  const schema = loaded.schema as AuthoredEntityOrSingleSchema
  if (schema.slot || target.id !== 'root:fields') {
    return field
  }

  return {
    ...(field as SchemaField),
    slot: normalizedSlot
  }
}
